module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921003834_T.82608ebd.jpg";